import { Injectable } from '@jkhy/frontend-utils/di';
import { WirePaymentDetailRequests } from '../../requests/reports/wire-payment-detail-requests';

@Injectable()
export class WirePaymentDetailService {
    constructor(private readonly requests: WirePaymentDetailRequests) {}

    public async fetchWireDetails(id: number) {
        return this.requests.fetchWireDetails(id);
    }

    public async updateExternallyProcessedFXWire(recordValues: object) {
        return this.requests.updateExternallyProcessedFXWire(recordValues);
    }
}
